module.exports = __webpack_public_path__ + "static/img/goto-webinar.60bc11f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goto-webinar.svg
// module id = 1430
// module chunks = 0